import { createAsyncThunk } from '@reduxjs/toolkit';
import { postMediaFilePermissionToProjectBank } from '../services/postMediaFilePermissionToProjectBank.service';

export const createMediaFilePermissionToProjectBank = createAsyncThunk(
  'file-permissions/project/images',
  async ({
    projectId,
    name,
    s3FileName,
    contentType,
    recordId,
    assignmentId,
    mediaTagsToAdd,
    // Set by the invoice-scan path, whose photos are already in S3 under the
    // temp scan prefix: the backend moves them across instead of taking a
    // second upload of the same bytes from the phone.
    copyFromTempInvoiceImages,
  }) => {
    const response = await postMediaFilePermissionToProjectBank({
      projectId,
      name,
      s3FileName,
      contentType,
      recordId,
      assignmentId,
      mediaTagsToAdd,
      copyFromTempInvoiceImages,
    });
    console.log('response', response);
    return response;
  }
);
